//#region src/modules/shared/ActivityFeed/getActivityKey.ts
/**
* Stable React key for an activity item. The RPC type has no top-level `id`, so
* we compose one from always-present fields. Stable keys keep the list DOM (and
* its scroll position) intact across re-renders — index keys do not.
*
* `detail` is serialized in full (not just `detail.scope`) and `subTitle` /
* `description` are folded in because high-frequency, same-user scopes like
* `user-geo-fence` and `user-status` otherwise collide on
* `timestamp|scope|userId|title`. Duplicate keys make React recreate DOM nodes
* on re-render, which resets the scroll position.
*/
function getActivityKey(item) {
	return [
		item.timestamp,
		JSON.stringify(item.detail),
		item.title,
		item.subTitle ?? "",
		item.description ?? ""
	].join("|");
}
//#endregion
export { getActivityKey };

//# sourceMappingURL=getActivityKey.js.map